import React, { useEffect, useState, useRef } from 'react';
import './MainInvoiceReceipts.scss';
import moment from 'moment';
import PrintMinimalistic from './PrintMinimalistic';
import PrintDetailed from './PrintDetailed';
import { Menu, MenuItem, Divider } from '@mui/material';
import ReactToPrint from "react-to-print";

function ReceiptRows({
  eachReceipt,
  patientName,
  mocPatientId,
  patientAge,
  patientGender,
  primaryConsultant,
  centerName,
  totalAdvanceAmount,
  brandName,
  companyName
}: any) {

  const [invoiceIds, setInvoiceIds] = useState<any>([]);
  const [services, setServices] = useState<any>([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const componentRef: any = useRef<any>(null)
  const componentRefDetailed: any = useRef<any>(null)

  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    let invId: any = [];
    let treatments: any = [];
    eachReceipt?.invoicesAndTransactions?.map((invIdEach: any) => {
      if (invIdEach?.invoiceOutput?.mocInvoiceId) {
        invId.push(invIdEach?.invoiceOutput?.mocInvoiceId);
      }
    });
    eachReceipt?.invoicesAndTransactions?.map((invIdEach: any) => {
      invIdEach?.invoiceOutput?.invoiceItems?.map((treatmentEach: any) => {
        if (!treatmentEach?.archive) {
          treatments.push(treatmentEach?.treatmentAndDetails);
        }
      });
    });
    setServices(treatments);
    setInvoiceIds(invId);
  }, [eachReceipt]);

  return (
    <tr className='receipt-row'>
      <td className='rs-date content-center'>{moment(eachReceipt?.receiptDateTime).format('DD-MM-YYYY')}</td>
      <td className='rs-id content-center'>{eachReceipt?.mocReceiptId}</td>
      <td className='rs-invoice-id content-center'>{invoiceIds?.length > 0 ? invoiceIds?.join(', ') : '-'}</td>
      <td className='rs-services content-center'>{services?.length > 0 ? services?.join(', ') : '-'}</td>
      <td className='rs-amount content-center'>{eachReceipt?.totalAmountPaid?.toFixed(2)}</td>
      <td className='rs-mode-of-payment content-center'>{eachReceipt?.transactions?.[0]?.modeOfPayment}</td>
      <td className='rs-minimalis-print content-center'>
        <img
          title='Print options'
          src='../../../../../../assets/images/printDropdown.svg'
          alt='print icon'
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        />
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <ReactToPrint
            copyStyles={true}
            trigger={() => (
              <MenuItem>Minimalistic</MenuItem>
            )}
            // @ts-ignore
            content={() => componentRef.current}
            onBeforePrint={handleClose}
          />
          <Divider sx={{ width: '98%', margin: '0 auto' }} />
          <ReactToPrint
            copyStyles={true}
            trigger={() => (
              <MenuItem>Detailed</MenuItem>
            )}
            // @ts-ignore
            content={() => componentRefDetailed.current}
            onBeforePrint={handleClose}
          />
        </Menu>
      </td>

      <PrintMinimalistic
        printRef={componentRef}
        receipt={eachReceipt && eachReceipt}
        patientName={patientName}
        mocPatientId={mocPatientId}
        patientAge={patientAge}
        patientGender={patientGender}
        primaryConsultant={primaryConsultant}
        centerName={centerName}
        brandName={brandName}
        companyName={companyName}
      />

      <PrintDetailed
        componentRefDetailed={componentRefDetailed}
        receipt={eachReceipt && eachReceipt}
        patientName={patientName}
        mocPatientId={mocPatientId}
        patientAge={patientAge}
        patientGender={patientGender}
        primaryConsultant={primaryConsultant}
        centerName={centerName}
        brandName={brandName}
        companyName={companyName}
        totalAdvanceAmount={totalAdvanceAmount}
        transactionNotes={eachReceipt?.transactions?.[0]}
      />
    </tr>
  );
};

export default ReceiptRows;
